import { LOCALES, getDefaultLocale, isNewI18n, loadLanguages } from 'moka-i18n';

export function transformApplyFormLocale(locale: LOCALES | 'default' | 'auto') {
  if (locale === 'default') {
    return LOCALES.ZH_CN;
  } else if (locale === 'auto') {
    return getDefaultLocale();
  } else {
    return locale;
  }
}

export async function loadLanguagesForApplyInfo(
  applyForm: {
    locales: (LOCALES | 'default' | 'auto')[];
  }[] = []
) {
  try {
    const languages = applyForm
      .map((item) => ({
        ...item,
        locales: item.locales.map(transformApplyFormLocale),
      }))
      .reduce<LOCALES[]>((acc, cur) => [...acc, ...(cur.locales || [])], []);
    if (isNewI18n()) {
      return await loadLanguages(Array.from(languages));
    }
  } catch (error) {
    console.error(error);
    // 出错了也不能影响页面正常显示，需要返回一个成功的 Promise
    return Promise.resolve();
  }
}
